export default __webpack_public_path__ + "static/media/dropboximages.23b50ba9.jpg";